import { Component, OnInit } from '@angular/core';
import { ProjectsService } from '../services/projects.service';
import { ReportService } from '../services/report.service';

@Component({
  selector: 'app-email-list',
  templateUrl: './email-list.component.html',
  styleUrl: './email-list.component.scss'
})
export class EmailListComponent implements OnInit {
  projects: Array<{id: string, name: string}> = [];
  roles: string[] = [];
  emails: any;

  constructor(
    private readonly projectService: ProjectsService,
    private readonly reportsService: ReportService
  ) { }

  ngOnInit() {
    this.projectService.getProjectRoles().subscribe((_: any) => {
      _.forEach((project: any) => {
        this.projects.push({id: project.projectId, name: project.projectName});
        project.roles.forEach((role:string) =>{
          if(!this.roles.includes(role)) {
            this.roles.push(role);
          }
        });
      });
    });
  }
  run() {
    var projects: string[] = [];
    var projectCheckboxes = document.querySelectorAll("input.project-checkbox:checked");
    projectCheckboxes.forEach((checkbox: any) => {
      projects.push(checkbox.value);
    });

    var roles: string[] = [];
    var roleCheckboxes = document.querySelectorAll("input.role-checkbox:checked");
    roleCheckboxes.forEach((checkbox: any) => {
      roles.push(checkbox.value);
    });

    this.reportsService.getEmailList(projects, roles)
    .subscribe((_: any) => {
      var emails: string[] = [];
      _.forEach((item: any) => {
        emails.push(item.name + " <" + item.email + ">");
      });
      this.emails = emails.join(';');
    });
  }
  copy($event: any) {
    var results = document.querySelector("textarea");
    results?.select();
    document.execCommand('copy');
    results?.setSelectionRange(0, 0);
    $event.target.focus();
  }
}
